import { FC } from 'react';
import { Box, Skeleton } from '@mui/material';
import { Container } from '@/components';

import styles from './styles.module.scss';

export const PricingSkeleton: FC = () => {
  const cards = Array(4).fill(0);

  return (
    <Box style={{}}>
      <Container>
        <Skeleton variant="text" className={styles.title} />

        <Skeleton variant="rectangular" className={styles.switcher} />

        <Box className={styles.cards}>
          {cards.map((_, i) => (
            <Skeleton
              key={i}
              variant="rectangular"
              className={styles.card}
              animation="wave"
            />
          ))}
        </Box>

        <Skeleton variant="rectangular" className={styles.other} animation="wave" />
      </Container>
    </Box>
  );
};
